module.exports = __webpack_public_path__ + "img/NO.d9a11761.svg";